<template>
  <v-sheet
    color="white"
    elevation="5"
    rounded
    class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3"
  >
    <div class="profile-content">
      <v-row>
        <v-col cols="9">
            <h1>
               <span v-if="litterId">Litter ID #{{ litterId }}</span>
               <span v-else>New litter</span>
              <span v-if="litterInfo.whelpingDate"> whelped on {{ $dateUtils.formatDate(litterInfo.whelpingDate) }}</span>
            </h1>
        </v-col>
        <v-col cols="3">       
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>
       <v-tabs v-model="tab">
        <v-tab key="litterEntry"> Litter entry </v-tab>
        <v-tab key="litterPuppies"> Puppies </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="litterEntry">
          <LitterEntry :litterId="litterId" />
        </v-tab-item>
        <v-tab-item key="litterPuppies"> 
          <LitterPuppies :litterId="litterId" />
        </v-tab-item>
       </v-tabs-items>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import LitterEntry from "@/components/Admin/Entries/LitterEntry.vue";
import LitterPuppies from "@/components/Admin/Details/Litters/LitterPuppies.vue";

import litterService from "@/services/admin/litterService";

import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "LitterDetails",
  components: {
    LitterEntry,
    LitterPuppies
  },
  data: function() {
    return {
      tab: null,
      litterInfo: {

      }
    };
  },
  methods: {
    reloadData: function() {
      if (this.litterId) {
        litterService
          .getLitterById(this.litterId)
          .then((res) => {
            this.litterInfo = res;
          })
          .catch(this.$handleError);
      }
    }, 
  },    
  created: function() {
    this.reloadData();
  },
  watch: {
    litterId: function(newVal: String) {
      this.reloadData();
    },
  },
  props: {
    litterId: { type: Number },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
